var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#activate_svg__clip0_1841_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5c-3-3-6-1-6-1l7 7s2-3-1-6zM4.654 19c3 3 6 1 6 1l-7-7s-2 3 1 6z",
    fill: "#ADC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.553 11.975l.415-.414a4.616 4.616 0 00-6.529-6.529l-.415.415a.363.363 0 000 .514l6.015 6.014a.363.363 0 00.514 0zm.884.884l.415-.415a5.866 5.866 0 00-8.297-8.296l-.414.415c-.63.63-.63 1.651 0 2.281l6.014 6.015c.63.63 1.652.63 2.282 0z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.058 10.942l-7-7 .884-.884 7 7-.884.884z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.646 2.353L20 6l-2-2L21.646.353a.5.5 0 01.707 0l1.293 1.293a.5.5 0 010 .707z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.447 12.025l-.415.414a4.616 4.616 0 106.528 6.529l.415-.415a.363.363 0 000-.514L5.96 12.025a.363.363 0 00-.513 0zm-.884-.884l-.415.415a5.866 5.866 0 008.296 8.296l.415-.415c.63-.63.63-1.651 0-2.281L6.844 11.14a1.613 1.613 0 00-2.281 0z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.058 20.942l-7-7 .884-.884 7 7-.884.884z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.353 21.646L4 18l2 2-3.647 3.646a.5.5 0 01-.707 0L.353 22.353a.5.5 0 010-.707z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12.585l1.732-1.732a.5.5 0 000-.707l-.379-.378a.5.5 0 00-.707 0L7.414 11.5 8.5 12.585zm2.439-1.024a1.5 1.5 0 000-2.122l-.379-.378a1.5 1.5 0 00-2.12 0L6 11.5 8.5 14l2.439-2.44zM12.5 16.585l1.732-1.732a.5.5 0 000-.707l-.379-.378a.5.5 0 00-.707 0L11.414 15.5l1.086 1.085zm2.439-1.024a1.5 1.5 0 000-2.122l-.379-.378a1.5 1.5 0 00-2.12 0L10 15.5l2.5 2.5 2.439-2.44z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "activate_svg__clip0_1841_579"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.08aede58b26ab22bb01cdcb55be7ea57.svg";
export { ForwardRef as ReactComponent };